import { Observable } from 'rxjs';

import { AbstractCrudServiceMock } from './abstract-crud.service.mock';
import { PageResponse } from '../../models/page-response';
import { PaulaObstructionCode } from '../../models/paula-obstruction-code';
import { ObstructionCodeService } from '../obstruction-code.service';

export const mockObstructionCodes: PaulaObstructionCode[] = [
    {
        id: 1,
        code: 'Niet thuis',
        name: 'Niet thuis',
    }
];

export class ObstructionCodeServiceMock extends AbstractCrudServiceMock<PaulaObstructionCode> implements ObstructionCodeService {
    constructor() {
        super(mockObstructionCodes);
    }

    list(): Observable<PageResponse<PaulaObstructionCode>> {
        return super.getAll();
    }
}
